const key = "chatPanelOpen";

export const readChatPanelOpen = () => localStorage.getItem(key) === "true";

export const writeChatPanelOpen = (open: boolean) =>
  localStorage.setItem(key, String(open));
